export default "__VITE_ASSET__C$zFPCcy__"